module["exports"] = [
  "Pan",
  "Pani"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/name/prefix.js
// module id = 1739
// module chunks = 0